export default class Score {

  required = null;
  fulfilled = null;
  percentage = null;

  constructor() {
  }
}
